var map = {
	"./Book.vue": [
		"8bf3",
		"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3",
		"default.json-account~default.json-notifications~views-Book~views-HistoricalData",
		"views-Book~views-HistoricalData",
		"views-Book"
	],
	"./ChinaMap.vue": [
		"02fe",
		"chunk-a1496f46",
		"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3",
		"views-ChinaMap"
	],
	"./CrossAnalysis.vue": [
		"e15a",
		"chunk-a1496f46",
		"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3",
		"views-CrossAnalysis"
	],
	"./HistoricalData.vue": [
		"d7df",
		"chunk-a1496f46",
		"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3",
		"default.json-account~default.json-notifications~views-Book~views-HistoricalData",
		"views-Book~views-HistoricalData",
		"views-HistoricalData"
	],
	"./Knowledge.vue": [
		"6602",
		"chunk-a1496f46",
		"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3",
		"views-Knowledge"
	],
	"./LocalSheet.vue": [
		"8bce",
		"chunk-a1496f46",
		"views-LocalSheet"
	],
	"./Nation.vue": [
		"19fc",
		"chunk-a1496f46",
		"views-Nation"
	],
	"./NationalSheet.vue": [
		"a0f7",
		"chunk-a1496f46",
		"views-NationalSheet"
	],
	"./News.vue": [
		"a2f9",
		"views-News"
	],
	"./Pie.vue": [
		"90bb",
		"chunk-a1496f46",
		"views-Pie"
	],
	"./Profile.vue": [
		"c66d",
		"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3",
		"views-Profile"
	],
	"./ProvinceData.vue": [
		"27b6",
		"chunk-a1496f46",
		"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3",
		"views-ProvinceData"
	],
	"./QuestionList.vue": [
		"50c1",
		"chunk-a1496f46",
		"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3",
		"views-QuestionList"
	],
	"./Sheet.vue": [
		"4448",
		"chunk-a1496f46",
		"views-Sheet"
	],
	"./WorldMap.vue": [
		"54ac",
		"chunk-a1496f46",
		"default.json-account~default.json-search~views-Book~views-ChinaMap~views-CrossAnalysis~views-Histori~27a0e5f3",
		"views-WorldMap"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;